import "./ReachOut.module.css";
import Navigation from "@/reusable_sections/Header";
import StartYourJourney from "./sections/StartYourJourney";
import TheRoadToClosing from "./sections/TheRoadToClosing";
import CommonQuestions from "./sections/CommonQuestions";
import EssentialResources from "./sections/EssentialResources";
import FooterInformation from "@/reusable_sections/Footer";
export default function ReachOutPage() {
  return <div>
      <Navigation />
      <StartYourJourney />
      <TheRoadToClosing />
      <CommonQuestions />
      <EssentialResources />
      <FooterInformation />
    </div>;
}